import React from 'react';

import { cva } from 'class-variance-authority';

import { cn } from '../../lib/utils';

// rounded-lg keeps the row tile concentric with GlassWrapper's rounded-xl shell: 12px outer − 4px (p-1) padding = 8px inner.
// The tile background is painted on the button itself (not an absolutely-positioned overlay) — a fading
// overlay layer forces per-row re-rasterization on hover, which makes icons and text visibly shift.
const buttonVariants = cva(
  'w-full cursor-pointer rounded-lg px-2.5 py-2.5 text-left text-xs duration-100 ease-out motion-safe:transition-colors',
  {
    variants: {
      variant: {
        default: 'text-gray-800 dark:text-neutral-200',
        danger: 'text-red-600 dark:text-red-400',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

const hoverVariants = cva('', {
  variants: {
    variant: {
      default: 'hover:bg-white dark:hover:bg-neutral-400/40',
      danger: 'hover:bg-white dark:hover:bg-neutral-400/40',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

const activeVariants = cva('', {
  variants: {
    variant: {
      default: 'bg-white dark:bg-neutral-400/40',
      danger: 'bg-white dark:bg-neutral-400/40',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export function MenuButton({ children, variant = 'default', isActive, onClick, onMouseMove, className, ...props }) {
  const showActiveState = isActive !== undefined;

  return (
    <button
      type="button"
      onClick={onClick}
      onMouseMove={onMouseMove}
      className={cn(
        buttonVariants({ variant }),
        !showActiveState && hoverVariants({ variant }),
        showActiveState && isActive && activeVariants({ variant }),
        className,
      )}
      {...props}
    >
      <span>{children}</span>
    </button>
  );
}
